import { fetchCommercialFeatures } from 'gdl/commercial/commercialFeature/CommercialFeaturesSlice'
import { isNil } from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useOutletContext, useParams } from 'react-router'
import useTitles from 'common/hooks/useTitles'

const InstanceLicenseApp = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const { instance } = useOutletContext()

    useTitles(() => [{
        label: 'Instance',
        href: '/instance',
    }, {
        label: isNil(instance) ? 'Chargement...' : (instance.name ?? 'Inconnue'),
        href: `/instance/${id}`,
    }, {
        label: 'Licence',
        href: `/instance/${id}/license`,
    }], [instance, id])

    useEffect(() => {
        dispatch(fetchCommercialFeatures())
    }, [dispatch])

    return (
        <div>LICENCE</div>
    )
}

export default InstanceLicenseApp